import React, { Component } from 'react';
import './ProductFilter.css';
import { Select } from 'antd';
import { observer, inject } from 'mobx-react';
import isFunction from 'lodash/isFunction';

@inject('subscriptionsStore', 'translationsStore', 'filterStore')
@observer
export default class ProductFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMainProducts: null
    };
  }

  changeMainProducts = selectedMainProducts => {
    this.setState({ selectedMainProducts });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      //props.status === false means the filter is not present. If here means the filter has been removed
      this.reset();
    }
    if (this.state.selectedMainProducts && prevState.selectedMainProducts !== this.state.selectedMainProducts) {
      this.props.filterStore.add('subscriptionFilter_product', subscription =>
        this.state.selectedMainProducts && this.state.selectedMainProducts.length === 0
          ? true
          : this.state.selectedMainProducts.some(selectedProduct => subscription.products.findIndex(product => product.name === selectedProduct) !== -1)
      );
    }
  }

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.changeMainProducts(null);
    }
  };

  render() {
    const { translationsStore, subscriptionsStore } = this.props;
    const { selectedMainProducts } = this.state;

    return (
      <div className="ProductFilter" id="ProductsFilter">
        <div className="filterTitle">{translationsStore.translate('subscriptionManager.filter.product')}</div>

        <div className="selectContainer">
          <Select
            mode="multiple"
            value={selectedMainProducts || []}
            getPopupContainer={() => document.getElementById('ProductsFilter')}
            onChange={this.changeMainProducts}
            optionFilterProp="description"
            menuItemSelectedIcon={<div />}
          >
            {subscriptionsStore.mainProducts.map(product => (
              <Select.Option key={product} description={product}>
                {product}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionAdvancedFilter/filters/ProductFilter/ProductFilter.js